'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Parse a string to a boolean. Throw error if string is neither "true" nor "false"
 */
const parseBoolean = (value) => {
    if (value !== 'true' && value !== 'false') {
        throw new Error('Cannot parse value');
    }
    return value === 'true';
};

exports.parseBoolean = parseBoolean;
//# sourceMappingURL=parse-boolean.js.map
